import { axios } from "@Root/API";

export const getSupervisors = params => {
  return axios.get("contacts/type/academic", {
    params
  });
};
